import { Box, Button, Container } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { findIndex, map } from 'lodash';
import { useTranslation } from 'react-i18next';
import navBtnList from '../../../../../constants/strings/Dashboard/navbar';
import './dashboard-navbar.scss';
import ProgressSpinner from '../../../../UI/ProgressSpinner/ProgressSpinner';
import MenuDropDown from '../../../../UI/CustomElements/MenuDropDown/MenuDropDown';
import { routePath } from '../../../../../constants/strings/RoutePath';
import { useUserGroupRole } from '../../../../../hooks/useUserGroupRole';

const DashboardNavbar = () => {
    const location = useLocation();
    const { t } = useTranslation();
    const walletUser = useSelector(
        (state) => state?.auth?.data?.WalletUserSettings,
    );
    const isLoading = useSelector((state) => state.dashboard.isLoading);
    const navigate = useNavigate();
    const { isUserGroupAdmin } = useUserGroupRole();

    const filteredNavList = useMemo(
        () =>
            navBtnList.filter((item) => {
                // Some destinations act on behalf of the whole user group and are
                // therefore admin-only regardless of the user group type.
                if (item.requiresUserGroupAdmin && !isUserGroupAdmin) {
                    return false;
                }
                if (item.userGroup === 'both') {
                    return true;
                }
                if (item.key === 'batch_creation') {
                    return (
                        item.userGroup === walletUser?.usergroupType &&
                        walletUser?.usergroup?.isPaymentBatch
                    );
                }
                return item.userGroup === walletUser?.usergroupType;
            }),
        [isUserGroupAdmin, walletUser],
    );

    const [activeMenu, setActiveMenu] = useState({
        index: 1,
        value: navBtnList?.[1]?.label,
    });
    useEffect(() => {
        // Index against the filtered list so the mobile dropdown's active option
        // lines up with the options it was actually given.
        const activeIndex = findIndex(
            filteredNavList,
            (menu) => menu.route === location.pathname,
        );
        setActiveMenu({
            index: activeIndex,
            value: filteredNavList?.[activeIndex]?.label,
        });
    }, [filteredNavList, location.pathname]);

    const grouped = map(filteredNavList, 'label');

    const menuClickHandler = (event, e) => {
        setActiveMenu({ index: e, value: event?.target?.value });
        navigate(filteredNavList[e].route);
    };

    const navbarClickHandler = (loc) => {
        navigate(loc);
    };
    return (
        <Container maxWidth="xl">
            {isLoading && <ProgressSpinner />}
            {location.pathname !== routePath.accountSettings && (
                <Box
                    className="dash-nav-container"
                    sx={{ display: { lg: 'none', xs: 'flex' } }}
                >
                    <MenuDropDown
                        options={grouped}
                        userGroupType={walletUser?.usergroupType}
                        active={activeMenu}
                        menuClickHandler={(event, e) =>
                            menuClickHandler(event, e)
                        }
                    />
                </Box>
            )}
            <Box
                className="dash-nav-container"
                sx={{ display: { lg: 'flex', xs: 'none' } }}
            >
                {filteredNavList.map((item, index) => (
                    <Button
                        className={` dashboard-nav-btn ${item.className}`}
                        key={`${index}${item.route}`}
                        variant={
                            item.route === location.pathname
                                ? 'contained'
                                : 'text'
                        }
                        startIcon={item.icon}
                        onClick={() => navbarClickHandler(item.route)}
                    >
                        {walletUser &&
                        walletUser?.usergroupType === 'Builder' &&
                        item.label === 'Payor'
                            ? t('navbar-payee')
                            : t(`${item.i18n}`)}
                    </Button>
                ))}
            </Box>
        </Container>
    );
};
export default DashboardNavbar;
